import { Injectable } from '@angular/core';
import { Http , RequestOptions , Headers} from '@angular/http';
//import { Toast } from '@ionic-native/toast';
import 'rxjs/Rx';


let apiUrl ='https://api.fahrdienstpro.de/takeoff_api/';

@Injectable()
export class AuthService {

  constructor(public http : Http) {
    console.log('Hello AuthService Provider');
  }

  postData(data_parm,method) {
    return new Promise((resolve, reject) => {
    
  	    var headers = new Headers();
        //headers.append("Accept", 'application/json');
         //headers.append('Content-Type', 'application/json' );
        let options = new RequestOptions({ headers: headers });
	

       this.http.post(apiUrl +method,data_parm,options)
          .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
        });

    });

  }

  getData(temp,data_parm,method) {
    return new Promise((resolve, reject) => {
    
        var headers = new Headers();
        //headers.append("Accept", 'application/json');
        // headers.append('Content-Type', 'application/json' );
        let options = new RequestOptions({ headers: headers });
  
   

     
        this.http.get(apiUrl +method + data_parm,options)
          .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
        });
    });

  }


  //  ParseInstallation(data_parm,method) {
  //   return new Promise((resolve, reject) => {
    
  //       var headers = new Headers();
       
  //       headers.append('X-Parse-Application-Id', '74363d626f35267b1a691ee6494e6ad2cade8231' );
  //       headers.append('X-Parse-Master-Key', '74363d626f35267b1a691ee6494e6ad2cade8231' );
  //       headers.append('Content-Type', 'application/json' );
  //       let options = new RequestOptions({ headers: headers });
  
  //       this.http.post(parseUrl+method, JSON.stringify(data_parm),options)
  //         .subscribe(res => {
  //           resolve(res.json());
  //         }, (err) => {
  //           reject(err);
  //       });

  //   });

  // }

  // ParseGetMessage(data_parm,method) {
  //   return new Promise((resolve, reject) => {
    
  //       var headers = new Headers();
       
  //       headers.append('X-Parse-Application-Id', '74363d626f35267b1a691ee6494e6ad2cade8231' );
  //       headers.append('X-Parse-Master-Key', '74363d626f35267b1a691ee6494e6ad2cade8231' );
  //       headers.append('Content-Type', 'application/json' );
  //       let options = new RequestOptions({ headers: headers });
    
  //       this.http.get(parseUrl +method,options)
  //         .subscribe(res => {
  //           resolve(res.json());
  //         }, (err) => {
  //           reject(err);
  //       });
       
  //   });

  // }




}



// WEBPACK FOOTER //
// ./src/providers/auth.ts